module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_rogaland_neg.f043dc44.png";